import BaseModelAPI from '../BaseModelAPI';

export default class ReportNgList extends BaseModelAPI {

	static entity = 'newreport2002list'
	static entityName = 'reportng';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
